"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.join = void 0;
var constants_1 = require("../constants");
var camelCaseToDash_1 = __importDefault(require("./camelCaseToDash"));
var processModifiers_1 = require("./processModifiers");
var join = function (classNames) { return classNames.join(' '); };
exports.join = join;
var composeClassNames = function (className, modifiers) {
    if (modifiers === void 0) { modifiers = []; }
    var classNames = [className];
    for (var _i = 0, _a = processModifiers_1.filter(modifiers); _i < _a.length; _i++) {
        var modifier = _a[_i];
        classNames.push("" + className + constants_1.MODIFIER_DELIMITER + camelCaseToDash_1.default(modifier));
    }
    return exports.join(classNames);
};
exports.default = composeClassNames;
//# sourceMappingURL=composeClassNames.js.map